import { render, staticRenderFns } from "./TabCouponVoucherContent.vue?vue&type=template&id=28203eef&"
import script from "./TabCouponVoucherContent.vue?vue&type=script&lang=js&"
export * from "./TabCouponVoucherContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports